import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import { CONTACT } from "@/data/site";

export default function CtaBand() {
  return (
    <section id="contact" data-testid="cta-section" className="relative bg-slate-900 text-white overflow-hidden cli-noise">
      <div className="absolute inset-0 cli-grid-bg opacity-[0.15]" />
      <div className="absolute -left-20 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full bg-purple-900/20 blur-3xl" />
      <div className="relative max-w-[1240px] mx-auto px-6 lg:px-8 py-20 lg:py-24 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <p className="font-cli text-xs tracking-[0.2em] uppercase text-pink-300 mb-4">› let's talk</p>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold tracking-tight max-w-xl leading-[1.1]">
            Ready to hand off the IT headaches?
          </h2>
          <p className="mt-5 text-slate-300 text-base md:text-lg max-w-lg leading-relaxed">
            Leave your details and a London-based engineer will call you back — usually within one business hour. No sales scripts, no obligation.
          </p>
          <div className="mt-8 space-y-3 text-sm">
            <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors">
              <Phone className="h-4 w-4 text-pink-300" /> {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors">
              <Mail className="h-4 w-4 text-pink-300" /> {CONTACT.email}
            </a>
            <p className="flex items-center gap-3 text-slate-200">
              <Clock className="h-4 w-4 text-pink-300" /> Mon–Fri, 8am–6pm · 24/7 for managed clients
            </p>
          </div>
          <Link to="/managed-it" data-testid="cta-secondary-btn"
            className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-pink-300 hover:text-pink-200 transition-colors">
            Or explore Managed IT →
          </Link>
        </Reveal>

        <Reveal delay={0.1}>
          <ContactForm />
        </Reveal>
      </div>
    </section>
  );
}
